import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    theFirstLink: '',
    accountType: '',
  },
  getters: {
    userAccountType(state) {
      return state.accountType || localStorage.getItem('user_accountType')
    },
    /* 是否是演示账号 */
    isDemonstration(state) {
      const accountType = state.accountType || localStorage.getItem('user_accountType')
      if (accountType == 2 || accountType == 3) {
        return true
      }
      return false
    }
  },
  mutations: {
    setTheFirstLink(state, url) {
      state.theFirstLink = url
    },
    setAccountType(state, val) {
      console.log(state, val, '测试')
      state.accountType = val
    },
    logout(state) {
      console.log(state)
      state.accountType = undefined
    }
  },
  actions: {}
})
